import { Table } from "semantic-ui-react";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import articleDeliveryTypes from "astrid-firestore/src/api/articles/constants/articleDeliveryTypes";
import { canDeliverArticleToChannel } from "astrid-firestore/src/api/distribution/utils/deliverArticlesToChannels";

import Flex from "../../../../../components/Flex/Flex";
import useHasRight from "../../../../authorization/hooks/useHasRight";
import DropdownMenu from "../../../../ui/components/DropdownMenu/DropdownMenu";

import ArticleDeliveryStatus from "../../ArticleDeliveryStatus/ArticleDeliveryStatus";
import ArticleDistributeModal from "../../ArticleDistributeModal/ArticleDistributeModal";
import ArticleChannelPublicationStatus from "../../ArticlePublicationStatus/ArticleChannelPublicationStatus";

import useArticleDistributionChannelDropdownMenuOptions from "../hooks/useArticleDistributionChannelDropdownMenuOptions";
import abbreviateArticleCountries from "../utils/abbreviateArticleCountries";

import ArticleChannelDataCell from "./ArticleChannelDataCell";
import ConfirmEnableDisableChannel from "./ConfirmEnableDisableChannel";

export default function ArticleChannels({ publisher, article, channels }) {
	const { t } = useTranslation();

	const hasRight = useHasRight();

	const [disableChannel, setDisableChannel] = useState(false);
	const [delivery, setDelivery] = useState(false);

	const dropdownMenuOptions = useArticleDistributionChannelDropdownMenuOptions({
		article,
		publisher,
		setDisableChannel,
	});

	return (
		<>
			<Table basic="very">
				{channels.map((channel) => {
					return (
						<Table.Row key={channel.id}>
							<Table.Cell collapsing style={{ paddingLeft: "1.2em" }}>
								{channel.name}
							</Table.Cell>

							<Table.Cell collapsing>
								<ArticleChannelPublicationStatus article={article} channel={channel} />
							</Table.Cell>

							<ArticleChannelDataCell
								article={article}
								channel={channel}
								attribute="announcementDate"
								label={t("announced", "Announced")}
							/>

							<ArticleChannelDataCell
								article={article}
								channel={channel}
								attribute="releaseDate"
								label={t("published", "Published")}
							/>

							<ArticleChannelDataCell
								article={article}
								channel={channel}
								attribute="takedownDate"
								label={t("unpublished", "Unpublished")}
							/>

							<ArticleChannelDataCell
								article={article}
								channel={channel}
								attribute="countries"
								label={t("countries", "Countries")}
								renderValue={(countries) => abbreviateArticleCountries(countries)}
							/>

							<Table.Cell />

							<Table.Cell collapsing style={{ paddingRight: "1em" }}>
								<Flex gap="1em">
									<ArticleDeliveryStatus
										article={article}
										channel={channel}
										onClick={
											hasRight("articles.view") &&
											((e, { type }) => {
												if (
													canDeliverArticleToChannel({ article, channel, deliveryType: type })
												) {
													setDelivery({
														[channel.id]: {
															metadata: type === articleDeliveryTypes.METADATA,
															artifact: type === articleDeliveryTypes.ARTIFACT,
														},
													});
												}
											})
										}
									/>

									{hasRight("articles.view") && (
										<DropdownMenu options={dropdownMenuOptions(channel)} />
									)}
								</Flex>
							</Table.Cell>
						</Table.Row>
					);
				})}
			</Table>

			{disableChannel && (
				<ConfirmEnableDisableChannel
					article={article}
					channel={disableChannel}
					onClose={() => setDisableChannel(false)}
				/>
			)}

			{delivery && (
				<ArticleDistributeModal
					delivery={delivery}
					publisher={publisher}
					articles={[article]}
					channels={channels}
					onClose={() => setDelivery(false)}
				/>
			)}
		</>
	);
}
